import { ref, onMounted, onUnmounted } from '@vue/composition-api';

export default function useLifecycleHook() {
  const mounted = ref(false);

  onMounted(() => {
    mounted.value = true;
  });

  onUnmounted(() => {
    mounted.value = false;
  });

  return {
    mounted,
  };
}
